import { FintechPapiEmployee } from 'src/api/interfaces';
import { Employee } from '../interfaces/interface';

/**
 * Utility class to map PAPI employee data to legacy Employee interface
 * This maintains backward compatibility with existing UI components
 */
export class PapiEmployeeMapper {
  /**
   * Map a single FintechPapiEmployee to Employee interface
   * @param papiEmployee - Employee data from PAPI API
   * @returns Employee object compatible with existing UI
   */
  static mapToEmployee(papiEmployee: FintechPapiEmployee): Employee {
    const basicInfo = papiEmployee.basicInfo || {};
    const job = papiEmployee.job || {};
    const workLocation = papiEmployee.workLocation || {};
    const emailAddresses = papiEmployee.emailAddresses || {};

    return {
      login_name: (basicInfo.login || '').toLowerCase(),
      employee_name: `${basicInfo.firstName || ''} ${basicInfo.lastName || ''}`.trim(),
      employee_internal_email_address: emailAddresses.PINT || emailAddresses.PGML || basicInfo.primaryEmail || '',
      job_title_name: basicInfo.businessTitle || '',
      location_city_name: workLocation.city || '',
      location_state_name: workLocation.country || '',
      job_level_name: job.jobLevel || '',
      employee_assistant_employee_id: 'assistantPersonId' in job ? job.assistantPersonId || '' : '',
      emplid: basicInfo.legacyEmployeeId || '',
      department_name_current: basicInfo.costCenterName || '',
      displayName: `${basicInfo.firstName || ''} ${basicInfo.lastName || ''}`.trim(),
      badgeColor: basicInfo.badgeColor || '',
      timezone: workLocation.timezone || '',
      timeZoneId: workLocation.timeZoneId || ''
    };
  }

  /**
   * Map an array of FintechPapiEmployees to Employee array
   * @param papiEmployees - Array of employee data from PAPI API
   * @returns Array of Employee objects compatible with existing UI
   */
  static mapToEmployees(papiEmployees: FintechPapiEmployee[]): Employee[] {
    return papiEmployees.map((emp) => this.mapToEmployee(emp));
  }
}
